import { AppNS } from 'app';
import SummaryTextList from 'app/ui_v2/components/summary-text-list/SummaryTextList';

import { Box, Card, CardContent, useTheme } from '@mui/material';

import { SUBJECT_TYPES } from '../helpers';

export interface ExternalDataProps {
  meta: AppNS.Params;
  defaults: Partial<AppNS.Ticket>;
}

export default function ExternalData(props: ExternalDataProps) {
  const { meta, defaults } = props;

  const theme = useTheme();

  const itemsConfig = {
    color: theme.palette.text.primary,
    fontSize: '1.6rem',
    spacing: 2.5,
    flexWrap: 'wrap',
  };

  const textList = [
    {
      label: 'Subject Type:',
      desc: SUBJECT_TYPES.find((item) => item.id === defaults?.subjectType)?.name,
    },
    {
      label: 'Subject:',
      desc: meta?.subjectName,
    },
  ];

  if (defaults?.parentTicketId) {
    textList.unshift({
      label: 'Parent Ticket:',
      desc: `#${defaults?.parentTicketId} - ${meta?.parentTicketType}`,
    });
  }

  return (
    <Card className="no-shadow card-type-light" sx={{ mb: -1 }}>
      <CardContent>
        <Box sx={{ mb: -3 }}>
          <SummaryTextList items={textList} opts={itemsConfig} />
        </Box>
      </CardContent>
    </Card>
  );
}
